<div fxLayout>
  <sbnb-subnav fxHide.lt-md [header]="'INBOX.INBOX' | transloco">
    <sbnb-saved-segments key="threads" [activeId]="activeSegmentUuid"></sbnb-saved-segments>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <div class="mobile__padding">
      <h2 class="mb-0">{{ activeSegmentTitle ? activeSegmentTitle : 'Loading...' }}</h2>

      <sbnb-helptext-wrapper
        class="helptext-wrapper-type-content"
        [area]="'content'"
        [pageId]="'inbox'"></sbnb-helptext-wrapper>

      <sbnb-helptext-wrapper [area]="'intro'" [pageId]="'inbox'"></sbnb-helptext-wrapper>

      <div class="inbox__filters-container" fxLayout="row wrap" fxLayout.lt-lg="column">
        <div fxFlex>
          <sbnb-filter
            *ngIf="segmentFilterDefaults"
            [defaultFilters]="segmentFilterDefaults"
            componentName="threads"
            (filterChanged)="handleFilterChanged($event)"
            (reset)="filterReset()"></sbnb-filter>
        </div>
        <div fxFlex="480px" fxLayout fxLayoutAlign="start start" fxLayoutGap="12px" fxFlex.lt-lg>
          <sbnb-search-bar
            fxFlex
            placeholderText="Reservation code, guest name, email or phone..."
            [initialVal]="searchCriteria"
            [debounceTimeMs]="1500"
            (searchChanged)="searchUpdated($event)"></sbnb-search-bar>

          <sbnb-add-manual-booking-button
            *ngIf="perms$.hasAccessTo(Features.PERM_MANAGE_RESERVATIONS) | async"
            (bookingChanged)="onManualBookingChanged()"
            fxHide.lt-lg></sbnb-add-manual-booking-button>
        </div>
      </div>
    </div>

    <div class="inbox__items">
      <div *ngIf="loading" class="table__no-items">Loading conversations...</div>

      <ng-container *ngIf="!loading">
        <sbnb-no-items
          *ngIf="(!loading && !inboxItems) || inboxItems?.length === 0"
          icon="contact-support"
          text="No conversations found matching these filters"></sbnb-no-items>

        <ng-container *ngIf="inboxItems && inboxItems?.length > 0">
          <div *ngIf="checkedConversations?.length > 0" class="select-all-container">
            <mat-checkbox
              class="select_all__checkbox"
              aria-label="Select All"
              [checked]="areAllThreadsOnPageSelected()"
              (change)="$event ? toggleAll($event) : null">
              Select all on this page
            </mat-checkbox>
          </div>

          <a
            *ngFor="let item of inboxItems; trackBy: trackInboxItem"
            class="inbox__item"
            [class.inbox__item-read]="item.read"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="8px"
            [routerLink]="['/inbox/thread', item.uuid]">
            <mat-checkbox
              class="select__checkbox"
              [checked]="selectedExists(item)"
              (change)="selectConversationcheckboxChecked($event, item)"
              (click)="$event.stopPropagation()"></mat-checkbox>

            <span *ngIf="!item.read" class="raspberry-dot"></span>
            <div class="inbox__item-guest-container" fxFlex="40px">
              <img
                class="inbox__guest-img box-shadow"
                [src]="item.guest.image"
                onerror="this.src='/assets/images/profile-default.png'" />
            </div>

            <div
              class="thread-viewers"
              *ngIf="getUsersViewingThread(item.uuid)?.length > 0"
              data-element="thread-viewers">
              <app-active-user-avatar
                *ngFor="let user of getUsersViewingThread(item.uuid).slice(0, 3); let i = index"
                [user]="user"
                [matTooltip]="
                  user.first_name +
                  (getUsersViewingThread(item.uuid).length > 3 && i === 2
                    ? ' and ' + (getUsersViewingThread(item.uuid).length - 2) + ' more are'
                    : ' is') +
                  ' viewing this thread'
                "></app-active-user-avatar>
            </div>

            <div fxFlex class="inbox__message-details">
              <div fxLayout fxLayoutGap="8px" fxLayoutAlign="start center">
                <span
                  fxFlex
                  class="inbox__guest-name"
                  [class.inbox__bold]="!item.read"
                  fxLayout
                  fxLayoutAlign="start center"
                  fxLayoutGap="8px">
                  <span class="ellipsis">{{ item.guest.name }}</span>
                  <sbnb-icon-platform
                    [platform]="item.guest.platform"
                    [height]="'14px'"
                    [width]="'14px'"></sbnb-icon-platform>

                  <sbnb-sentiment-label
                    *ngIf="item.label && (sentimentAnalysisEnabled$ | async)"
                    [label]="item.label"
                    dataElement="inbox-thread-label"
                    class="flex"></sbnb-sentiment-label>

                  <sbnb-icon *ngIf="item.starred" icon="star" class="text-lemon-darker"></sbnb-icon>
                </span>

                <div
                  *ngIf="
                    item.booking.status.description_key !== 'inquiry' &&
                    item.booking.status.description_key !== 'pending' &&
                    item.booking.status.description_key !== 'request_to_book' &&
                    !item.has_alteration_request
                  "
                  fxHide
                  fxShow.lt-lg
                  class="inbox__right text__small"
                  [matTooltip]="item.last_message_at | date: 'medium'">
                  {{ item.last_message_at | timeAgo }}
                </div>
              </div>

              <span
                *ngIf="item.listing.image || item.listing.name"
                fxHide
                fxShow.lt-lg
                class="inbox__guest-name-mobile ellipsis text__xsmall">
                {{ item.advanced_status ? item.advanced_status : item.booking.status.description }}
              </span>

              <span class="ellipsis text__small thread-last-message" [class.strong]="!item.read">
                {{ item.last_message ? item.last_message : 'No last message' }}
              </span>

              <span
                fxHide
                fxShow.lt-lg
                *ngIf="item?.listing?.property_name"
                class="ellipsis text__small thread-last-message"
                style="line-height: 20px; display: flex; margin-top: 8px">
                {{ item.listing.property_name }}
              </span>
            </div>
            <sbnb-mini-listing-img
              fxHide.lt-lg
              [imgSrc]="item.listing.image"
              [imgAlt]="item.listing.name"></sbnb-mini-listing-img>

            <div *ngIf="item.listing.image || item.listing.name" fxFlex fxHide.lt-lg class="inbox__message-details">
              <span class="inbox__guest-name ellipsis">
                {{ item.advanced_status ? item.advanced_status : item.booking.status.description }}
              </span>

              <span class="ellipsis text__small">{{ item.listing.property_name }}</span>
            </div>

            <div
              fxFlex="125px"
              fxHide.lt-lg
              class="inbox__right text__small"
              [matTooltip]="item.last_message_at_label"
              *ngIf="
                (item.booking.status.description_key !== 'inquiry' &&
                  item.booking.status.description_key !== 'pending' &&
                  item.booking.status.description_key !== 'request_to_book' &&
                  !item.has_alteration_request) ||
                (item.booking.status.description_key === 'pending' &&
                  item.booking?.payment_status?.includes('_pending'))
              ">
              {{ item.last_message_at | timeAgo }}
            </div>

            <div
              fxFlex="125px"
              fxHide.lt-lg
              *ngIf="item.booking.status.description_key === 'inquiry'"
              class="inbox__right text__small">
              <sbnb-button
                *ngIf="item.supports?.pre_approvals === true"
                label="Pre-Approve"
                type="primary-teal"
                size="mini"
                [loading]="item.preapproveLoading"
                (click)="$event.stopPropagation()"
                (clicked)="preapproveThread(item, $event)"></sbnb-button>
            </div>

            <div
              *ngIf="
                item.booking.status.description_key === 'pending' && !item.booking?.payment_status?.includes('_pending')
              "
              fxFlex="125px"
              fxLayoutAlign="end center"
              class="inbox__right text__small">
              <div *ngIf="!item.booking.is_custom_quote" class="badge badge-lemon-clear">Review</div>
            </div>

            <div fxFlex="125px" class="inbox__right text__small" *ngIf="item.has_alteration_request">
              <div class="badge badge-grass-clear flex items-center gap-2">
                <mat-icon class="!size-4 text-base/4">calendar_today</mat-icon>
                <span>See alteration</span>
              </div>
            </div>
          </a>
        </ng-container>
      </ng-container>
    </div>

    <hospitable-pagination
      *ngIf="
        paginationData &&
        !loading &&
        (paginationData.page_numbers?.total_pages > 1 || paginationData._links?.next || paginationData._links?.prev)
      "
      class="mt-4"
      [pagination]="paginationData"
      (pageChanged)="handlePageChanged($event)"
      (cursorChanged)="handleCursorChanged($event)"></hospitable-pagination>

    <div
      *ngIf="checkedConversations.length > 0 && !resolvingThreads && !unresolvingThreads"
      fxLayout
      fxLayoutAlign="start center"
      class="properties__merge-container box-shadow-heavier">
      <strong class="text__small" fxFlex>
        {{ checkedConversations.length }} conversation{{ checkedConversations.length > 1 ? 's' : '' }}
        {{ checkedConversations.length === maxSelectableItemsForBroadcast ? '(max)' : '' }}
        selected
      </strong>
      <div fxLayout fxLayoutGap="8px">
        <button mat-flat-button class="button__small button__secondary" (click)="sendBroadcast()">
          Send a message
        </button>

        <button
          *ngIf="checkedConversations && !checkedConversations[0].resolved"
          mat-flat-button
          class="button__small"
          (click)="markAsResolved()">
          Resolve
        </button>

        <button
          *ngIf="checkedConversations && checkedConversations[0].resolved"
          mat-flat-button
          class="button__small"
          (click)="markAsUnresolved()">
          Unresolve
        </button>
      </div>
    </div>
  </main>
</div>

<sbnb-resolving-thread-progress
  *ngIf="resolvingThreads"
  [totalCount]="checkedConversations?.length"
  [progressCount]="resolvedProgressCount"></sbnb-resolving-thread-progress>

<sbnb-resolving-thread-progress
  *ngIf="unresolvingThreads"
  operation="Unresolved"
  [totalCount]="checkedConversations?.length"
  [progressCount]="resolvedProgressCount"></sbnb-resolving-thread-progress>

<sbnb-mobile-sidebar [title]="'INBOX.INBOX' | transloco">
  <sbnb-saved-segments key="threads" [activeId]="activeSegmentUuid"></sbnb-saved-segments>
  <sbnb-add-manual-booking-button
    *ngIf="perms$.hasAccessTo(Features.PERM_MANAGE_RESERVATIONS) | async"></sbnb-add-manual-booking-button>
</sbnb-mobile-sidebar>
